export enum DimmingOverlayVariant {
  standard = 'standard',
  bright = 'bright'
}
